import React,{Component,useState } from 'react';
import { NavLink } from 'react-router-dom';

function SignInPage() {
   
    
      const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleCheck = (e) => {
    // Simulate "no user found"
    e.preventDefault();
    if (email.trim() === '') {
      setMessage('');
    } else {
      setMessage('No user with that email');
    }
  };
      
    

        
    return(
         <div>

            <div class="main-banner companybg newonetop pri thissignup">
                <div class="container"><header class="main-header d-flex justify-content-between signinroyalty"><div class="site-logo">
                    <a href="/"> 
            <img class="desklogo signupbl royalty" src="/assets/images/home4/logo_home.png" /></a>
            </div>
            </header>
            </div> 
            </div>

             <div class="signinpage gu newsignpage">
             

             <section class="cklsign firststepsign ">
    <div class="pklsi">
        <div class="iopsi">
            <header class="uiopj">
               

                

                <h1 class="c3fa29956 c926e5028 logintitle">ROYALTY TAX</h1>

                <div class="c2077a76c cac95ad60">
                    <p class="c76075b34 c2fad6637"></p>
                </div>
            </header>

            <div class="c439d90a0 c37cd0ac8">
            <div  novalidate="" class="signupForm hidden-logged-in signupForm-homepage-center" __bizdiag="1239199729" __biza="WJ__">
                    <div class="signupForm-container">
                        <div class="signupForm-row">
                            <form onSubmit={handleCheck}>
                        <div class="form-group email-form-g">
                                
                                <input onChange={(e) => {
          setEmail(e.target.value);
          setMessage(''); // Clear message on change
        }} type="email" name="email" value={email} required  class="form-control emaillogin" placeholder="Email address" id="work-email" />
                            </div>

                            <div class="submit-btn">
                                <button onClick={handleCheck} id="go-to-nextStep"   class="btn btn-lg btn-flat btn-block btn-primary firststepcon">Log In</button>
                            </div>
                           
                     <p className={message ? 'loginmessage active' : 'loginmessage'}>  {message ? message : ''}</p>
    </form>
                        </div>
                    </div>
                </div>
               

               

           

                
            </div>
        </div>
    </div>
</section>
 

<section class="cklsign laststepsign">
<div class="pklsi">
    <div class="iopsi">
        <header class="uiopj">
            <div
                title="HashiCorp"
                id="custom-prompt-logo"
                
            ></div>

            

            <h1 class="c3fa29956 c926e5028">Enter Your Password</h1>

            
        </header>

        <div class="c439d90a0 c37cd0ac8">
        <form action="login" method="get" novalidate="" class="signupForm hidden-logged-in signupForm-homepage-center" __bizdiag="1239199729" __biza="WJ__">
                <div class="signupForm-container">
                    <div class="signupForm-row">
                    <div class="form-group">
                            
                            <input type="email"  required  class="form-control emaillogin2" placeholder="Email address" id="work-email2" />
                        </div>
                        <div class="form-group">
                            
                            <input type="password" required  class="form-control" placeholder="Password" id="work-email" />
                        </div>
                        <div class="form-group ckl">
                        <a
                        class="c82c0b9b3 c8061fbcb ck"
                        href="#"
                    >
                        Forgot password?
                    </a> </div>

                        <div class="submit-btn">
                            <button id="go-to-nextStep" class="btn btn-lg btn-flat btn-block btn-primary">Continue</button>
                        </div>
                       
                    </div>
                </div>
            </form>
           

           

            
        </div>
    </div>
</div>
</section>


             </div>




 </div>
    );
}



export default SignInPage;
